import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    VStack,
} from '@chakra-ui/react';
import { Field } from 'formik';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import NameField from 'components/forms/new/formikFormFields/NameField';

const ItemCodeTrackingName1Field = ({
    darkMode,
    errors,
    touched,
    ...props
}) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.trackingName1 && touched.trackingName1}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Tracking Name 1
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Enter a tracking name for this item code mapping.
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            alignItems: 'flex-start',
                            paddingTop: '8px',
                        }}>
                        <VStack width="100%" alignItems="normal">
                            <Field
                                component={NameField}
                                id="trackingName1"
                                name="trackingName1"
                                error={errors.trackingName1}
                                {...props}
                            />
                        </VStack>
                    </Box>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Enter a tracking name."
                        ariaLabel="item-code-tracking-name1-tip"
                        left="25px"
                        top="30px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default ItemCodeTrackingName1Field;
